import React from 'react'

const PointsCashPlaceholder = props => (
  <div className='method-creditcard col-12 mt-1 mb-2'>
    <div className='range-step row border-color-ui-3 border-bottom pb-2 mb-2'>
      <div className='col-6 col-md-3 order-2 order-md-1 px-0'>
        <div className='row mx-0'>
          <div className='col-11 px-2 radius bg-ui-3 py-2' />
        </div>
      </div>
      <div className='col-12 col-md-6 order-1 order-md-2 px-0'>
        <div className='row align-items-center h-100'>
          <div className='col-12 px-2 mb-2 mb-md-0 mx-0'>
            <div className='col-12 px-2 radius bg-ui-3 pt-1 mb-1' />
          </div>
        </div>
      </div>
      <div className='col-6 col-md-3 order-3 order-md-3 form-field'>
        <div className='row mx-0'>
          <div className='col-11 px-2 radius bg-ui-3 py-2' />
        </div>
      </div>
    </div>
    <div className='payment-step h-auto row'>
      <div className='col-12 col-md-6 px-0'>
        <div className='row mx-0 justify-content-between'>
          <div className='col-12 px-2 radius bg-ui-3 py-2 mb-1' />
          <div className='col-12 px-2 radius bg-ui-3 py-2 mb-1' />
          <div className='col-12 px-2 radius bg-ui-3 py-2 mb-1' />
          <div className='col px-2 radius bg-ui-3 py-2 mb-1 mr-1' />
          <div className='col px-2 radius bg-ui-3 py-2 mb-1' />
        </div>
      </div>
      <div className='col-12 col-md-6 mt-3 mt-md-0'>
        <div className='row align-items-center h-100'>
          <div className='col-12 txt-center pos-relative inserted'>
            <div className='image-credit-card front_credit-card'>
              <div>
                <img
                  src='https://via.placeholder.com/265x165/D2DCDE?text=&nbsp;'
                  className='creditcard w-100 my-1 pt-1 pb-0'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default PointsCashPlaceholder



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/PointsCashPlaceholder.js